import { useContext } from 'react';

import { UserApplicationContext } from '../contexts/UserApplicationProvider';

function useUserApplicationMapping() {
    return useContext(UserApplicationContext);
}

export default useUserApplicationMapping;
